import React, { useState , useEffect} from "react";
import BgWithText from '../../components/backgroundWithText/BgWithText';
import { asset } from "../../helpers/dom.helper";
import i18n from "../../i18n";
import Body from "./body";
import Forms from "./forms";
import Info from "./info";
import { Helmet } from "react-helmet";
import { en as dataEn, th as dataTh } from './LocalDatabase/LocalDatabase';
import "./styles/style.css";

export default function BecomePartners() {

  const [data, setData] = useState()

  i18n.on('languageChanged', (lng) => {
    const nextData = (lng === 'en' ? dataEn : dataTh)
    setData(nextData)
  })

  useEffect(() => {
    const reloadCount = sessionStorage.getItem('reloadCount');
    if(reloadCount < 2) {
      sessionStorage.setItem('reloadCount', String(reloadCount + 1));
      window.location.reload();
      window.history.scrollRestoration = 'manual'
    } else {
      sessionStorage.removeItem('reloadCount');
    }
  },[])

  if (!data) {
    return <div className="text-center">Loading ...</div>
  }

  const {helmet, header, body, info_list: info, info_title: title, info_subtitle: subtitle } = data

  return (
    <div>
      <Helmet>
        <title>ร่วมเป็นพันธมิตรกับเรา - Silverman แอปพลิเคชันบริหารนิติบุคคล</title>
        <meta name="description" content="ร่วมเป็นพันธมิตรกับเรา Silverman ต้อนรับพันธมิตรทางธุรกิจมาร่วมเปลี่ยนแปลงวงการนิติบุคคลไปข้างหน้า เพื่อบริหารงานนิติบุคคลและมอบผลลัพธ์ที่ดีที่สุดให้แก่ลูกบ้าน" />
        <meta name="keywords" content={helmet.meta_keyword} />
        <link rel="canonical" href="https://silverman.app/become-partner" />
      </Helmet>
      <BgWithText data={header} image={asset('/images/becomePartner/bg-image.jpg')} />

      <div className="main-container">
        <div className="body-list-forms">
          <div className="left-container">
            <Body data={body} />
            <Info data={info} title={title} subtitle={subtitle} />
          </div>
          <div className="right-container">
            <Forms />
          </div>
        </div>
      </div>
    </div>
  )

}
